const api_keys = require('../api_keys.json.erb')
const infoWindowHtml = require("./infoWindow.html")

class MapBuilder {

  constructor(mapTarget) {
    this.mapTarget = mapTarget;
  }

  setup() {
    var script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${api_keys.google_api_key}&callback=initMap&libraries=geometry,places`;
    script.defer = true;

    window.initMap = () => {
      this.bounds = new google.maps.LatLngBounds();
      this.googleMap = new google.maps.Map(this.mapTarget.get(0));

      const input = document.getElementById("localisation");

      const options = {
        componentRestrictions: { country: "fr" },
        fields: ["formatted_address", "geometry", "name"],
        strictBounds: false
      };

      new google.maps.places.Autocomplete(input, options);

      var infoWindow = new google.maps.InfoWindow();

      const jsonInfos = JSON.parse(this.mapTarget.attr("data-json"));

      jQuery.each(jsonInfos['programs'], (i, program) => {
        var latlng = { lat: program.lat, lng: program.lng }

        var marker = new google.maps.Marker({
          map: this.googleMap,
          position: latlng
        });

        google.maps.event.addListener(marker, 'click', () => {

          var dom = $(infoWindowHtml)
          dom.find("#info-window-img").attr("src", program.img_url);
          dom.find("#info-window-button").attr("href", program.url);
          dom.find("#info-window-button").html(program.button_title);
          dom.find("#info-window-typologies").html(program.display_typologies);
          dom.find("#info-window-name").html(program.name);

          infoWindow.setContent(dom.html());
          infoWindow.open(this.googleMap, marker);
        });

        this.bounds.extend(marker.position);
      });

      // Don't zoom in too far on only one marker
      if (this.bounds.getNorthEast().equals(this.bounds.getSouthWest())) {
        var extendPoint1 = new google.maps.LatLng(this.bounds.getNorthEast().lat() + 0.02, this.bounds.getNorthEast().lng() + 0.02);
        var extendPoint2 = new google.maps.LatLng(this.bounds.getNorthEast().lat() - 0.02, this.bounds.getNorthEast().lng() - 0.02);
        this.bounds.extend(extendPoint1);
        this.bounds.extend(extendPoint2);
      }

      this.fitBounds();
    };

    document.head.appendChild(script);
  }

  fitBounds() {
      this.googleMap.fitBounds(this.bounds);
  }
};

var buildMap = function () {
  var builder = new MapBuilder($(this));
  builder.setup();

  return builder;
};

export default buildMap;
